import _ from 'lodash'

export const getMetadatosFiles = (files, uploadedFiles) => {
  let metadatosFiles = []

  _.forEach(files, f => {
    let index = _.findIndex(uploadedFiles, u => {
      return u.nombre === f.filename
    })

    if (index >= 0) {
      metadatosFiles.push({
        idDocumento: uploadedFiles[index].idDocumento,
        descripcion: f.description
      })
    }
  })

  return metadatosFiles
}
